import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent: React.FC = () => {
  const [showBanner, setShowBanner] = useState<boolean>(false);

  useEffect(() => {
    // Check if user has already given consent
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="cookie-consent">
      <div className="cookie-consent__container">
        <div className="cookie-consent__content">
          <div className="cookie-consent__icon">
            <i className="bx bx-cookie"></i>
          </div>
          
          <div className="cookie-consent__text">
            <h3>We use cookies</h3>
            <p>
              This website uses cookies to enhance your browsing experience and provide personalized content. 
              By continuing to use this site, you consent to our use of cookies. 
              <a href="/privacy-policy" className="cookie-consent__link">Learn more</a>
            </p>
          </div>
          
          <div className="cookie-consent__actions">
            <button 
              onClick={declineCookies}
              className="cookie-consent__btn cookie-consent__btn--secondary"
            >
              Decline
            </button>
            <button 
              onClick={acceptCookies}
              className="cookie-consent__btn cookie-consent__btn--primary"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent; 